// «Участники» — cine e în comunitate, pentru toată lumea.
//
// Până acum lista de participanţi era o pagină de administrare: rânduri cu adrese de
// e-mail, un selector de rol şi un buton roşu de blocare. Asta e o unealtă, nu un loc
// unde te uiţi să vezi cu cine stai. Acum sunt două lucruri separate: aici e directorul
// public, iar rolurile şi blocările au rămas în «Модерация», unde intră doar personalul.
//
// Cartonaşe, nu rânduri: un rând spune „încă unul", un cartonaş cu poză spune „un om".
// Şi nu apare nicio adresă de e-mail — ea nu iese niciodată din administrare.

import { el, clear } from '../core/util.js';
import { icon } from '../ui/icons.js';
import { session } from '../core/session.js';
import { pictAvatar, pictCover } from '../ui/avatars.js';
import { toast } from '../ui/components.js';
import { adu } from '../core/cache.js';

const json = async (path, metoda) => {
  const resp = await fetch(path, metoda ? { method: metoda } : {});
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || `Ошибка ${resp.status}`);
  return data;
};

/** „с 10 авг. 2026" — ziua exactă nu spune nimic, luna spune de când e omul aici. */
function dinCand(ts) {
  return new Date(ts * 1000).toLocaleDateString('ru-RU', { month: 'short', year: 'numeric' });
}

/** „был 5 мин назад" — cât de viu e locul se citeşte din asta, nu dintr-o cifră. */
function vazut(ts) {
  if (!ts) return 'давно не заходил';
  const s = Math.floor(Date.now() / 1000) - ts;
  if (s < 300) return 'сейчас на сайте';
  if (s < 3600) return `был ${Math.floor(s / 60)} мин назад`;
  if (s < 86400) return `был ${Math.floor(s / 3600)} ч назад`;
  if (s < 7 * 86400) return `был ${Math.floor(s / 86400)} д назад`;
  return `был ${new Date(ts * 1000).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}`;
}

export class MembersSection {
  constructor(app) {
    this.app = app;
    this.items = [];
    this.cautare = '';
  }

  async mount(host) {
    this.root = el('div', { class: 'mb-section' });
    host.append(this.root);

    this.grilaEl = el('div', { class: 'mb-grid' });
    this.contorEl = el('span', { class: 'reports-hint' });

    const camp = el('input', {
      class: 'auth-input mb-cauta', type: 'search', placeholder: 'Найти по нику…',
      oninput: (e) => { this.cautare = e.target.value.trim().toLowerCase(); this.#randeaza(); },
    });

    this.root.append(el('div', { class: 'mb-doc' }, [
      el('div', { class: 'ideas-head' }, [
        el('h2', { class: 'ideas-title', text: 'Участники' }),
        this.contorEl,
      ]),
      el('p', { class: 'ac-intro', text: 'Все, кто здесь есть. Откройте профиль, '
        + 'чтобы посмотреть публикации и идеи — или написать лично.' }),
      camp,
      this.grilaEl,
    ]));

    await this.#incarca();
  }

  async #incarca() {
    if (!this.items.length) {
      clear(this.grilaEl).append(el('div', { class: 'fd-gol-mic', text: 'Загружаем…' }));
    }
    try {
      await adu('/api/community/members', () => json('/api/community/members'), (d) => {
        this.items = d.items || [];
        this.#randeaza();
      });
    } catch {
      if (!this.items.length) { this.items = []; this.#randeaza(); }
    }
  }

  #randeaza() {
    clear(this.grilaEl);
    const lista = this.cautare
      ? this.items.filter((u) => u.username.toLowerCase().includes(this.cautare))
      : this.items;

    this.contorEl.textContent = `${this.items.length} участников`;
    if (!lista.length) {
      this.grilaEl.append(el('div', { class: 'fd-gol', text: 'Никого не нашлось' }));
      return;
    }
    for (const u of lista) this.grilaEl.append(this.#card(u));
  }

  #card(u) {
    const av = el('span', { class: 'mb-av' });
    pictAvatar(av, u, 52);

    // Banda de sus a cartonaşului e coperta omului. Aşa cartonaşele nu arată toate la
    // fel, iar cine şi-a ales una îşi recunoaşte profilul din listă.
    const banda = el('div', { class: 'mb-banda' });
    pictCover(banda, u, u.status?.color);

    const eu = session.user?.username === u.username;
    const card = el('article', { class: 'mb-card' }, [
      banda,
      el('div', { class: 'mb-corp' }, [
        av,
        el('div', { class: 'mb-nume-rand' }, [
          el('span', { class: 'mb-nume', text: u.username }),
          u.role === 'owner' ? el('span', { class: 'chat-role', text: 'Владелец' })
            : u.role === 'admin' ? el('span', { class: 'chat-role', text: 'Админ' }) : null,
        ]),
        el('span', { class: 'mb-rang', style: { color: u.status?.color } }, [
          icon('medal', 10), el('span', { text: u.status?.name || '' }),
        ]),
        u.bio ? el('p', { class: 'mb-bio', text: u.bio }) : null,
        el('div', { class: 'mb-cifre' }, [
          el('span', { text: `${u.followers} подписчиков` }),
          el('span', { class: 'pf-punct', text: '·' }),
          el('span', { text: `${u.posts} публикаций` }),
        ]),
        el('div', { class: 'mb-jos' }, [
          el('span', { class: 'mb-vazut', text: vazut(u.seen_at) }),
          el('span', { class: 'mb-din', text: `с ${dinCand(u.created_at)}` }),
        ]),
        el('div', { class: 'mb-actiuni' }, eu ? [
          el('button', { class: 'btn', text: 'Мой профиль',
            onclick: () => this.app.navigate('/profile/') }),
        ] : [
          el('button', { class: 'btn', text: 'Профиль',
            onclick: () => this.app.navigate(`/profile/${encodeURIComponent(u.username)}/`) }),
          el('button', { class: 'btn', title: 'Написать лично',
            onclick: () => this.#scrie(u.username) }, [icon('send', 12)]),
        ]),
      ]),
    ]);

    // Clic oriunde pe cartonaş duce la profil: butonul e pentru cine caută butonul,
    // cartonaşul e pentru cine dă direct clic pe om.
    card.onclick = (e) => {
      if (e.target.closest('button')) return;
      this.app.navigate(eu ? '/profile/' : `/profile/${encodeURIComponent(u.username)}/`);
    };
    return card;
  }

  async #scrie(nume) {
    try {
      const { deschideMesaje } = await import('../ui/messages.js');
      deschideMesaje(nume);
    } catch (err) { toast(err.message, 'error'); }
  }

  unmount() {
    this.root?.remove();
  }
}
